export const coldChainManual = [
  {
    date: "คู่มือ 2569",
    title: "คู่มือบริหารจัดการวัคซีนและระบบห่วงโซ่ความเย็น",
    url: "https://biologic.dld.go.th/images/files/doc-download/cold-chain/ColdChainSystemManual69.pdf",
  },
];
